module.exports = __webpack_public_path__ + "static/gallery-1-2e400f46c270fec2971e56aab171b2f2.jpg";